import { Table, TableCell, TableHead, TableHeader, TableRow, TableWrap } from '@/components/ui/Table';
import {
  AdTypeCell,
  CampaignNameCell,
  DateCell,
  DismissButton,
  EmptyTableMessage,
  formatRatio,
  SpActionButton,
} from '@/components/recommendations/ruleTables/ruleTableShared';
import { formatRecommendationCurrency } from '@/api/recommendationFormat';
import type { RuleCampaignRow } from '@/types/ruleRecommendations';

export function MissedSpendTable({
  profileId,
  rows,
  onIncreaseBudget,
  onDismiss,
}: {
  profileId: string;
  rows: RuleCampaignRow[];
  onIncreaseBudget: (row: RuleCampaignRow) => void;
  onDismiss: (row: RuleCampaignRow) => void;
}) {
  if (!rows.length) {
    return <EmptyTableMessage message="No campaigns match these rules for the selected range." />;
  }

  return (
    <TableWrap className="max-h-[28rem] overflow-y-auto">
      <Table>
        <TableHeader>
          <TableRow className="divide-y-0 hover:bg-transparent">
            <TableHead>Campaign</TableHead>
            <TableHead>Ad type</TableHead>
            <TableHead>Start date</TableHead>
            <TableHead>End date</TableHead>
            <TableHead className="text-right">Opportunity sales</TableHead>
            <TableHead className="text-right">Opportunity spend</TableHead>
            <TableHead className="text-right">ROAS</TableHead>
            <TableHead className="text-right">Daily budget</TableHead>
            <TableHead>Actions</TableHead>
          </TableRow>
        </TableHeader>
        <tbody>
          {rows.map((row) => (
            <TableRow key={row.campaignId}>
              <TableCell>
                <CampaignNameCell
                  profileId={profileId}
                  campaignId={row.campaignId}
                  campaignName={row.campaignName}
                  adProduct={row.adProduct}
                  campaignType={row.campaignType}
                />
              </TableCell>
              <TableCell>
                <AdTypeCell adProduct={row.adProduct} campaignType={row.campaignType} />
              </TableCell>
              <TableCell>
                <DateCell value={row.startDate} empty="—" />
              </TableCell>
              <TableCell>
                <DateCell value={row.endDate} />
              </TableCell>
              <TableCell className="text-right font-mono">
                {formatRecommendationCurrency(row.opportunitySales ?? 0)}
              </TableCell>
              <TableCell className="text-right font-mono">
                {formatRecommendationCurrency(row.opportunitySpend ?? 0)}
              </TableCell>
              <TableCell className="text-right font-mono">{formatRatio(row.roas)}</TableCell>
              <TableCell className="text-right font-mono">
                {row.dailyBudget == null ? '—' : formatRecommendationCurrency(row.dailyBudget)}
              </TableCell>
              <TableCell>
                <div className="flex flex-wrap gap-1">
                  <SpActionButton
                    adProduct={row.adProduct}
                    campaignType={row.campaignType}
                    onClick={() => onIncreaseBudget(row)}
                  >
                    Increase budget
                  </SpActionButton>
                  <DismissButton onClick={() => onDismiss(row)} />
                </div>
              </TableCell>
            </TableRow>
          ))}
        </tbody>
      </Table>
    </TableWrap>
  );
}
